import { DropdownOptionsPayload } from "../../../../../../models/DropdownOptionsPayload/dropdownOptionsPayload";

export const AddTruckFormProps = {
  BID_TOOL_BTN_TEXT: "Bid Tool",
  DRAWER_HEADER: "Add Material Details",
  TRUCK_TYPE_HEADER: "Truck Type",
  JOB_DETAILS_HEADER: "Job Details",
  ESTIMATED_QUANTITY_HEADER: "Estimated Quantity",
  TRUCK_PRICE_HEADER: "Truck Price Details",
  PROJECT_SUMMARY_HEADER: "Project Summary",
  CANCEL_BTN_TXT: "Cancel",
  SUBMIT_BTN_TXT: "Submit",
  REVENUE_TXT: "Revenue",
  COGS_TXT: "COGS",
  GROSS_PROFIT_TXT: "Gross Profit",
  PER_UNIT_TXT: "Per Unit",
  PROJECT_TXT: "Project",
  PERCENT_SALES_TXT: "% of Sales",
  ROUND_BOTTOM_TXT: "Round Bottom",
  STEP_DECK_TXT: "Stepdeck",
  END_DUMP_TXT: "End Dump",
  BELLY_DUMP_TXT: "Belly Dump",
  SUPER_DUMP_TXT: "Super Dump",
  HEAVY_HAUL_TXT: "Heavy Haul",
  WATER_TRUCK_TXT: "Water Truck",
  DRY_VAN_TXT: "Dry Van",
  FIFTEEN_DUMP_TXT: "15+ Ton Dump Truck",
  TEN_DUMP_TXT: "10+ Ton Dump Truck",
  POWER_ONLY_TXT: "Power Only",
  PNEUMATIC_TANKER_TXT: "Pneumatic Tanker",
  FALTBED_TXT: "Flatbed",
  TAB_FIELD_NAME: "truckTypeFilterOption",
  TON_TXT: "Ton",
  LOAD_TXT: "Load",
  HOUR_TXT: "Hour",
  YARD_TXT: "Yard",
  PICKUP_LOCATION_NAME: "pickupLocation",
  PICKUP_LOCATION_LABEL: "Pickup Location",
  PICKUP_LOCATION_COORDS_NAME: "pickupLocationCoordinates",
  PICKUP_LOCATION_COORDS_LABEL: "Pickup Coordinates",
  DELIVERY_LOCATION_COORDS_NAME: "deliveryLocationCoordinates",
  DELIVERY_LOCATION_COORDS_LABEL: "Delivery Coordinates",
  PICKUP_LOCATION_PLACEHOLDER: "Select",
  MATERIAL_NAME_NAME: "materialTruckName",
  MATERIAL_NAME_LABEL: "Material Name",
  MATERIAL_NAME_PLACEHOLDER: "Select",
  REQUIRED_QUANTITY_NAME: "quantity",
  REQUIRED_QUANTITY_LABEL: "Trucking Required Quantity",
  REQUIRED_MATERIAL_QUANTITY_NAME: "materialQuantity",
  REQUIRED_MATERIAL_QUANTITY_LABEL: "Material Required Quantity",
  REQUIRED_QUANTITY_PLACEHOLDER: "Enter quantity",
  TRUCK_PRICE_NAME: "truckingPrice",
  TRUCK_PRICE_LABEL: "Trucking Price",
  TRUCK_PRICE_PLACEHOLDER: "Enter truck price",
  MINIMUM_HOURS_NAME: "minimumHours",
  MINIMUM_HOURS_LABEL: "Minimum Hours",
  MINIMUM_HOURS_PLACEHOLDER: "Enter Hours",
  TRUCK_COST_NAME: "truckCost",
  TRUCK_COST_LABEL: "Trucking Cost",
  TRUCK_COST_PLACEHOLDER: "Enter truck cost",
  DELIVERY_LOCATION_NAME: "deliveryLocation",
  DELIVERT_LOCATION_LABEL: "Delivery Location",
  MATERIAL_DETAILS_HEADER: "Material Pricing Details",
  USE_MARKUP_NAME: "useMaterialMarkup",
  USE_MARKUP_LABEL: "Use Margin",
  USE_MARKUP_PLACEHOLDER: "Enter margin",
  MATERIAL_PRICE_NAME: "materialPrice",
  MATERIAL_PRICE_LABEL: "Material Price",
  MATERIAL_PRICE_PLACEHOLDER: "Enter material price",
  MATERIAL_COST_NAME: "materialCost",
  MATERIAL_COST_LABEL: "Material Cost",
  MATERIAL_COST_PLACEHOLDER: "Enter material cost",
  TRUCK_TYPE_ERROR_MSG: "Please Select Truck Type",
  BID_TOOL_WARNING:
    "There are unconfigured fields in the bid tool section. Please fill in the details to proceed",
  JOB_MAP_WARNING: "Select Pickup/Delievery Location to proceed",
  JOB_MAP_FAILURE: "Unable to open maps!",
  TRUCKING: "Trucking",
  MATERIAL: "Material",
  BID_TRUCK_PRICE_NAME: "truckPrice",
  BID_TRUCK_COST_NAME: "truckingCost",
  BID_TRUCK_TRUCK_TYPE_NAME: "truckType",
  TRUCKING_VENDOR: "truckingVendor",
  TRUCKING_VENDOR_LABEL: "Vendor",
  TRUCKING_VENDOR_PLACEHOLDER: "Select Vendor",
};
export const fieldsToValidate = [
  "ED_rate",
  "BD_rate",
  "5A+_rate",
  "DT_rate",
  "truckType",
  "texasDieselAvg",
  "RB_rate",
  "DT_biddingTons",
  "5A+_biddingTons",
  "BD_biddingTons",
  "ED_biddingTons",
  "RB_biddingTons",
  "truckRate",
  "oneWayTime",
  "oneWayMiles",
  "loadingTime",
  "unloadingTime",
  "deadheadForwardTime",
  "deadheadForwardMiles",
  "deadheadBackwardTime",
  "deadheadBackwardMiles",
  "timeBuffer",
  "loadsPerDayTruck",
  "initialPercentage",
  "truckPrice",
  "truckingCost",
  "actualBid",
  "averageNumberLoads",
  "maxNumberLoads",
];
export const bidToolValidationFields = [
  "ED_rate",
  "BD_rate",
  "5A+_rate",
  "DT_rate",
  "texasDieselAvg",
  "RB_rate",
  "DT_biddingTons",
  "5A+_biddingTons",
  "BD_biddingTons",
  "ED_biddingTons",
  "RB_biddingTons",
  "truckRate",
  "oneWayTime",
  "oneWayMiles",
  "loadingTime",
  "unloadingTime",
  "deadheadForwardTime",
  "deadheadForwardMiles",
  "deadheadBackwardTime",
  "deadheadBackwardMiles",
  "timeBuffer",
  "loadsPerDayTruck",
  "initialPercentage",
  "truckPrice",
  "truckingCost",
  "actualBid",
  "averageNumberLoads",
  "maxNumberLoads",
];
export const truckDetaildFormKeys = [
  "pickupLocation",
  "deliveryLocation",
  "truckType",
  "quantity",
  "truckingPrice",
  "truckCost",
  "materialTruckName",
];

export const truckVendorDetailKeys = [
  "useMaterialMarkup",
  "materialPrice",
  "materialCost",
  "quantity",
  "truckingPrice",
  "truckCost",
  "minimumHours",
];
export const bidFieldNumberKeys = [
  "initialPercentage",
  "loadsPerDayTruck",
  "actualBid",
  "averageNumberLoads",
  "maxNumberLoads",
];
export const BidToolFromKeys = [
  "truckPrice",
  "truckingCost",
  "initialPercentage",
  "actualBid",
  "averageNumberLoads",
  "maxNumberLoads",
  "oneWayMiles",
  "oneWayTime",
  "loadsPerDayTruck",
];
export const DrawerHeaderStyles = {
  backgroundColor: "#586370",
  padding: "1rem",
  color: "white",
};
export const DrawerHeaderBidToolStyles = {
  backgroundColor: "white",
  padding: "1rem",
  color: "white",
};

export const BidToolStyles = {
  borderRadius: "8px",
  padding: "0px 1.4rem",
};

export const CancelStyles = {
  color: "#586370",
  backgroundColor: "white",
  border: "1px solid #586370",
  borderRadius: "1px",
  fontFamily: "Montserrat, sans-serif",
  fontWeight: "500",
  fontSize: "14px",
  lineHeight: "17px",
  textShadow: "none",
  borderRadius: "8px",
};
export const SubmitStyles = {
  borderRadius: "8px",
};

export const sampleProjectSummaryHeader = [
  AddTruckFormProps.PER_UNIT_TXT,
  AddTruckFormProps.PROJECT_TXT,
  AddTruckFormProps.PERCENT_SALES_TXT,
];
export const sampleProjectSummaryBody = ({
  perUnitRevenue,
  projectRevenue,
  projectPercent,
  cogsPerUnit,
  projectCogs,
  cogsPercent,
  profitPerUnit,
  projectProfit,
  profitPercent,
}) => [
  [
    AddTruckFormProps.REVENUE_TXT,
    perUnitRevenue,
    projectRevenue,
    projectPercent,
  ],
  [AddTruckFormProps.COGS_TXT, cogsPerUnit, projectCogs, cogsPercent],
  [
    AddTruckFormProps.GROSS_PROFIT_TXT,
    profitPerUnit,
    projectProfit,
    profitPercent,
  ],
];

const getPercentToTwoPlaces = (number) => {
  return (number * 100).toFixed(2);
};

const getNumberToTwoPlaces = (number) => {
  return Number(Number(number).toFixed(2)) ?? null;
};

export const sampletProjectSummaryBodyMaterial = ({
  truckingCost,
  estimatedQuantity,
  materailEstimatedQuantity,
  materialCost,
  materialPrice,
  truckingPrice,
}) => {
  // Revenue -> Trucking
  const revenueTrucking_perUnit = getNumberToTwoPlaces(truckingPrice);
  const revenueTrucking_project = getNumberToTwoPlaces(
    revenueTrucking_perUnit * estimatedQuantity
  );
  // Revenue -> Material
  const revenueMaterial_perUnit = getNumberToTwoPlaces(materialPrice);
  const revenueMaterial_project = getNumberToTwoPlaces(
    revenueMaterial_perUnit * materailEstimatedQuantity
  );
  // COGS -> Trucking
  const cogsTrucking_perUnit = getNumberToTwoPlaces(truckingCost);
  const cogsTrucking_project = getNumberToTwoPlaces(
    cogsTrucking_perUnit * estimatedQuantity
  );
  // COGS -> Material
  const cogsMaterial_perUnit = getNumberToTwoPlaces(materialCost);
  const cogsMaterial_project = getNumberToTwoPlaces(
    cogsMaterial_perUnit * materailEstimatedQuantity
  );
  // Gross Profit -> Trucking
  const grossProfitTrucking_perUnit = getNumberToTwoPlaces(
    revenueTrucking_perUnit - cogsTrucking_perUnit
  );
  const grossProfitTrucking_project = getNumberToTwoPlaces(
    revenueTrucking_project - cogsTrucking_project
  );
  // Gross Profit -> Material
  const grossProfitMaterial_perUnit = getNumberToTwoPlaces(
    revenueMaterial_perUnit - cogsMaterial_perUnit
  );
  const grossProfitMaterial_project = getNumberToTwoPlaces(
    revenueMaterial_project - cogsMaterial_project
  );
  // Total Revenue
  const revenue_project = getNumberToTwoPlaces(
    revenueTrucking_project + revenueMaterial_project
  );
  const totalQuantity = estimatedQuantity + materailEstimatedQuantity;
  const revenue_perUnit = getNumberToTwoPlaces(
    totalQuantity > 0 ? revenueMaterial_perUnit + revenueTrucking_perUnit : 0
  );
  // Total COGS
  const cogs_project = getNumberToTwoPlaces(
    cogsTrucking_project + cogsMaterial_project
  );
  const cogs_perUnit = getNumberToTwoPlaces(
    totalQuantity > 0 ? cogsMaterial_perUnit + cogsTrucking_perUnit : 0
  );
  // Total Gross Profit
  const grossProfit_project = getNumberToTwoPlaces(
    revenue_project - cogs_project
  );
  const grossProfit_perUnit = getNumberToTwoPlaces(
    revenue_perUnit - cogs_perUnit
  );

  const revenue_sales = getPercentToTwoPlaces(1);
  const revenueTrucking_sales = getPercentToTwoPlaces(
    revenue_project > 0 ? revenueTrucking_project / revenue_project : 0
  );
  const revenueMaterial_sales = getPercentToTwoPlaces(
    revenue_project > 0 ? revenueMaterial_project / revenue_project : 0
  );
  const cogs_sales = getPercentToTwoPlaces(
    revenue_project > 0 ? cogs_project / revenue_project : 0
  );
  const cogsTrucking_sales = getPercentToTwoPlaces(
    revenueTrucking_project > 0
      ? cogsTrucking_project / revenueTrucking_project
      : 0
  );
  const cogsMaterial_sales = getPercentToTwoPlaces(
    revenueMaterial_project > 0
      ? cogsMaterial_project / revenueMaterial_project
      : 0
  );
  const grossProfit_sales = getPercentToTwoPlaces(
    revenue_project > 0 ? grossProfit_project / revenue_project : 0
  );
  const grossProfitTrucking_sales = getPercentToTwoPlaces(
    revenueTrucking_project > 0
      ? grossProfitTrucking_project / revenueTrucking_project
      : 0
  );
  const grossProfitMaterial_sales = getPercentToTwoPlaces(
    revenueMaterial_project > 0
      ? grossProfitMaterial_project / revenueMaterial_project
      : 0
  );
  return [
    [
      AddTruckFormProps.REVENUE_TXT,
      revenue_perUnit,
      revenue_project,
      revenue_sales,
    ],
    [
      AddTruckFormProps.TRUCKING,
      revenueTrucking_perUnit,
      revenueTrucking_project,
      revenueTrucking_sales,
    ],
    [
      AddTruckFormProps.MATERIAL,
      revenueMaterial_perUnit,
      revenueMaterial_project,
      revenueMaterial_sales,
    ],
    [AddTruckFormProps.COGS_TXT, cogs_perUnit, cogs_project, cogs_sales],
    [
      AddTruckFormProps.TRUCKING,
      cogsTrucking_perUnit,
      cogsTrucking_project,
      cogsTrucking_sales,
    ],
    [
      AddTruckFormProps.MATERIAL,
      cogsMaterial_perUnit,
      cogsMaterial_project,
      cogsMaterial_sales,
    ],
    [
      AddTruckFormProps.GROSS_PROFIT_TXT,
      grossProfit_perUnit,
      grossProfit_project,
      grossProfit_sales,
    ],
    [
      AddTruckFormProps.TRUCKING,
      grossProfitTrucking_perUnit,
      grossProfitTrucking_project,
      grossProfitTrucking_sales,
    ],
    [
      AddTruckFormProps.MATERIAL,
      grossProfitMaterial_perUnit,
      grossProfitMaterial_project,
      grossProfitMaterial_sales,
    ],
  ];
};
export const buttonOptionsProps = [
  { value: "both", label: "Both" },
  { value: "big", label: "Big" },
  { value: "small", label: "Small" },
];

export const buttonOptionsKeys = {
  BOTH: "both",
  BIG: "big",
  SMALL: "small",
};

export const SEARCH_FILTER_TYPE = "label";

export const getTruckOptions = (data: DropdownOptionsPayload) => {
  return data?.trucksData?.map((item) => ({
    label: item?.value,
    value: item?.value,
    truckCode: item?.truck_code,
  }));
};

export const getMaterialOptions = (data: []) => {
  return data?.map((item) => ({
    key: item?.id,
    label: item?.label,
    value: item?.id,
  }));
};
export const checkboxLabels = [
  {
    label: AddTruckFormProps.ROUND_BOTTOM_TXT,
    value: AddTruckFormProps.ROUND_BOTTOM_TXT,
  },
  {
    label: AddTruckFormProps.STEP_DECK_TXT,
    value: AddTruckFormProps.STEP_DECK_TXT,
  },
  {
    label: AddTruckFormProps.END_DUMP_TXT,
    value: AddTruckFormProps.END_DUMP_TXT,
  },
  {
    label: AddTruckFormProps.HEAVY_HAUL_TXT,
    value: AddTruckFormProps.HEAVY_HAUL_TXT,
  },
  {
    label: AddTruckFormProps.BELLY_DUMP_TXT,
    value: AddTruckFormProps.BELLY_DUMP_TXT,
  },
  {
    label: AddTruckFormProps.WATER_TRUCK_TXT,
    value: AddTruckFormProps.WATER_TRUCK_TXT,
  },
  {
    label: AddTruckFormProps.SUPER_DUMP_TXT,
    value: AddTruckFormProps.SUPER_DUMP_TXT,
  },
  {
    label: AddTruckFormProps.DRY_VAN_TXT,
    value: AddTruckFormProps.DRY_VAN_TXT,
  },
  {
    label: AddTruckFormProps.FIFTEEN_DUMP_TXT,
    value: AddTruckFormProps.FIFTEEN_DUMP_TXT,
  },
  {
    label: AddTruckFormProps.POWER_ONLY_TXT,
    value: AddTruckFormProps.POWER_ONLY_TXT,
  },
  {
    label: AddTruckFormProps.TEN_DUMP_TXT,
    value: AddTruckFormProps.TEN_DUMP_TXT,
  },
  {
    label: AddTruckFormProps.PNEUMATIC_TANKER_TXT,
    value: AddTruckFormProps.PNEUMATIC_TANKER_TXT,
  },
  {
    label: AddTruckFormProps.FALTBED_TXT,
    value: AddTruckFormProps.FALTBED_TXT,
  },
];

export const getMaterialPriceFromMargin = (
  materialCost?: number,
  margin?: number
) => {
  if (
    margin === null
    || margin === undefined
    || isNaN(margin)
  ) {
    return undefined;
  }
  const normalised = margin / 100;
  const materialPrice = materialCost / (1 - normalised);
  return materialPrice >= 0 ? Number(materialPrice).toFixed(2) : undefined;
};

export const getMarginPercentFromMaterialPrice = (
  materialPrice?: number,
  materialCost?: number
) => {
  if (
    materialPrice === null 
    || materialPrice === undefined
    || isNaN(materialPrice)
  ) {
    return undefined;
  }
  if (materialCost === 0) {
    return materialPrice === 0 ? "0.00" : "100.00";
  }
  if(materialPrice === 0) {
    return "-100.00";
  }
  const margin = ((materialPrice - materialCost) / materialPrice) * 100;
  return Number(margin).toFixed(2) ?? undefined;
};

export const negativeMarkupModalProps = {
  okButtonLabel: "Yes",
  cancelButtonLabel: "No",
  title: "Error",
  content: "Margin value is in negative. Do you wish to proceed?",
  width: "520px",
};

export const checkboxConstants = {
  label: "Same as job site location",
};
